import React, { useState, useEffect } from 'react';
import useAxiosPrivate from '../../../../hooks/useAxiosPrivate';

const SiteSelect = ({ value, onChange, required = false }) => {
    const [sites, setSites] = useState([]);
    const [loading, setLoading] = useState(true);
    const axiosPrivate = useAxiosPrivate();

    useEffect(() => {
        let isMounted = true;
        const fetchSites = async () => {
            try {
                const response = await axiosPrivate.get('/sites');
                if (isMounted) {
                    setSites(response.data);
                    setLoading(false);
                }
            } catch (error) {
                console.error("Error fetching sites:", error);
                if (isMounted) setLoading(false);
            }
        };

        fetchSites();
        return () => {
            isMounted = false;
        };
    }, [axiosPrivate]);

    return (
        <div className="mb-4">
            <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
                Specify Site
            </label>
            <select
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                required={required}
                disabled={loading}
            >
                <option value="">{loading ? 'Loading sites...' : 'Select Site'}</option>
                {sites.map((site) => (
                    <option key={site.id} value={site.id}>
                        {site.name} ({site.type})
                    </option>
                ))}
            </select>
        </div>
    );
};

export default SiteSelect;
